import { render, staticRenderFns } from "./PlpChip.vue?vue&type=template&id=5e3c0044&"
import script from "./PlpChip.vue?vue&type=script&lang=js&"
export * from "./PlpChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIconRemoveCircleOutline: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconRemoveCircleOutline.vue').default})
